import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  close: {},
}));
